import { ref } from "vue"
import {
  CSRF_TOKEN_FETCH_START,
  CSRF_TOKEN_FETCH_COMPLETE,
} from "@/constants/events"
import { setTopologyId } from "@/services/logger"
import { TOPOLOGY_CSRF } from "@/constants/topology"
import logger from "@/services/logger"
import { authClient } from "@/api/clients"

// Set topology ID for semantic logging
setTopologyId(TOPOLOGY_CSRF)

// LLM:METADATA
// :topology: [Domain:Security | Role:CSRFProtection | Pattern:Middleware]
// :relates-to: depends-on: "Backend API", uses: "authClient"
// :rationale: "CSRF tokens prevent cross-site request forgery attacks"
// :contract: pre: "CSRF token available", post: "Token included in request headers", invariant: "All state changes include CSRF token"
// :decision_cache: "Chose header-based CSRF tokens over form fields for SPA compatibility [SEC-003]"
// LLM:END

const csrfToken = ref(null)

async function fetchCsrfToken() {
  logger.info(CSRF_TOKEN_FETCH_START, "Fetching CSRF token from backend", {
    timestamp: Date.now(),
  })

  try {
    const response = await authClient.csrfToken()
    // createContractClient returns already validated response.data, not full axios response
    const token = response?.token || response?.data?.token

    if (!token) {
      throw new Error("CSRF token response does not include token payload")
    }

    csrfToken.value = token

    logger.info(
      CSRF_TOKEN_FETCH_COMPLETE,
      "CSRF token retrieved successfully",
      {
        tokenLength: token?.length,
        timestamp: Date.now(),
      }
    )

    return token
  } catch (error) {
    logger.error(CSRF_TOKEN_FETCH_COMPLETE, "Failed to fetch CSRF token", {
      error: error.message,
      timestamp: Date.now(),
    })
    throw error
  }
}

export { csrfToken, fetchCsrfToken }
